const SlopeConditions = {
    SOFT: 'SOFT',
    GRIPPY_SOFT: 'GRIPPY_SOFT',
    GRIPPY: 'GRIPPY',
    GRIPPY_HARD: 'GRIPPY_HARD',
    HARD: 'HARD'
}

export default SlopeConditions;
